import { CognitoIdentityCredentials } from "aws-sdk";
import { CognitoUser, CognitoUserPool, AuthenticationDetails, CognitoUserAttribute, CognitoIdToken } from "amazon-cognito-identity-js";
import awsAppConfig from './config';
import lsUtil from '../../common/lsUtil';
import { getCurrentLocale } from 'APP_ROOT/localization';
import jwt from 'jwt-simple';
import { tryCookieAuth } from './prototypeAuth';

export default class CognitoUtil {

    static userPool = new CognitoUserPool({
        UserPoolId: awsAppConfig.UserPoolId,
        ClientId: awsAppConfig.ClientId
    });

    static setLoginCredentials(result) {

        const loginUrl = `cognito-idp.${awsAppConfig.region}.amazonaws.com/${awsAppConfig.UserPoolId}`;
        const logins = {};
        const idTokenJWT = result.getIdToken().getJwtToken();
        lsUtil.setItem(lsUtil.AWS_COGNITO_USER_POOL_ID_TOKEN_JWT, idTokenJWT);
        logins[loginUrl] = idTokenJWT;

        var params = {
            IdentityPoolId: awsAppConfig.IdentityPoolId,
            Logins: logins
        };

        window.AWS.config.credentials = new CognitoIdentityCredentials(params);

        this.identityId = params.IdentityId;
    }

    static getIdentityId () {

        return this.identityId;

    }

    static getIdTokenJWT () {
        return lsUtil.getItem(lsUtil.AWS_COGNITO_USER_POOL_ID_TOKEN_JWT);

    }

    static login(email, password, onSuccess, onFail, onPasswordResetRequired, onNewPasswordRequired) {

        try {

            var me = this;

            this.cognitoUser = CognitoUtil.userPool.getCurrentUser();

            if (this.cognitoUser) CognitoUtil.logout();

            email = email.trim().toLowerCase();

            const authenticationDetails = new AuthenticationDetails({
                Username: email,
                Password: password
            });
            this.cognitoUser = new CognitoUser({ Username: email, Pool: CognitoUtil.userPool });
            this.cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function (result) {
                    CognitoUtil.setLoginCredentials(result);
                    window.AWS.config.credentials.get(function (err) {
                        if (err) {
                            console.error('error in credentials.get', err);
                            onFail(err);
                        } else {

                            if (!me.identityId) {
                                me.identityId = window.AWS.config.credentials.identityId;
                            }

                            CognitoUtil.cognitoUser.getUserAttributes((err, attrib_result) => {
                                if (err) {
                                    console.error('error in getUserAttributes', err);
                                    onFail(err);
                                    return;
                                }

                                // Check if the user should force change their password, the Klashwerks way
                                var i;
                                var len = attrib_result.length;
                                let vendor = null; // default vendor is raven
                                let franchiseViewNeeded = true; // RAV-5842: Force all users to franchise view (multi-account)
                                let userEmail = email;
                                let userStage = null;
                                let pendingInvite = null;
                                let preferredUsername = null;
                                
                                for(i = 0; i < len ;i++)
                                {
                                    const attributeName = attrib_result[i].Name;
                                    const attributeValue = attrib_result[i].Value;

                                    if (attributeName === "custom:extra_user_flags") {

                                        if(attributeValue.indexOf("vendor_telus") !== -1){
                                            vendor = "vendor_telus";
                                        }
                                    }

                                    // Check for pending invite
                                    // custom:invite_details=invite_<token>_<signature>
                                    // This means user has a not-finalized invite 
                                    // due to different reasons (e.g. user has closed the browser before finishing the invite)
                                    if (attributeName === "custom:invite_details") {
                                        if(attributeValue)
                                        {
                                            pendingInvite = CognitoUtil.getPendingInviteDetails(attributeValue);
                                        }
                                    }

                                    if (attributeName === "email") {
                                        userEmail = attributeValue;
                                    }

                                    if (attributeName === "preferred_username") {
                                        preferredUsername = attributeValue;
                                    }

                                    if (attributeName === "custom:linked_raven_stage") {
                                        userStage = attributeValue;
                                    }

                                    // if (attributeName === "custom:extra_user_flags" && attributeValue.indexOf("franchise_view") !== -1) {
                                    //    franchiseViewNeeded = true; 
                                    // }

                                    if(attributeName === "custom:extra_user_flags" &&
                                        attributeValue.indexOf("FORCE_CHANGE_PASSWORD") !== -1)
                                    {
                                        // Found force change password flag, need to request new password
                                        me.newPasswordRequiredFlag = true;
                                        onNewPasswordRequired({user:me.cognitoUser, 
                                            userAttributes: attrib_result,
                                            op: password 
                                            });

                                        return;
                                    }
                                }

                                if(pendingInvite) {
                                    pendingInvite.inviteEmail = userEmail;
                                    pendingInvite.driverName = preferredUsername;
                                    pendingInvite.nextStep = '/select-account';
                                }


                                // Fell through, that means we're good to go into the app
                                onSuccess({franchiseViewNeeded, email: userEmail, stage: userStage, pendingInvite});
                                const currentVendor = lsUtil.getItem('raven.vendor') || null;

                                if (vendor !== currentVendor) {
                                    window.location.reload();
                                }
                                if (vendor) {
                                    lsUtil.setItem('raven.vendor', vendor);
                                } else {
                                    lsUtil.removeItem('raven.vendor'); // mostly just useful for debugging purposes
                                }                    
                            });
                        }
                    });

                },
                onFailure: function (err) {
                    if (err.code === "PasswordResetRequiredException") {
                        onPasswordResetRequired();
                    } else {
                        console.error(err);
                        onFail(err);
                    }
                },
                newPasswordRequired: function (userAttributes, requiredAttributes) {
                    console.log("new password required");
                    this.newPasswordRequiredFlag = 'cognito';
                    onNewPasswordRequired({user:this.cognitoUser, 
                        userAttributes: userAttributes, 
                        requiredAttributes: requiredAttributes});
                },
                mfaRequired: function (data) {
                    //TODO implement this
                    console.error("mfa required!");
                    onFail()
                    //cognitoUser.sendMFAcode
                }
            });
        } catch (err) {
            console.error("Login Error", err);
            onFail(err)
        }
    }

    static mobileSpecialLogin(idToken, onSuccess, onFail) {

        if (this.cognitoUser) CognitoUtil.logout();

        //custom setLoginCredentials
        const loginUrl = `cognito-idp.${awsAppConfig.region}.amazonaws.com/${awsAppConfig.UserPoolId}`;
        const logins = {};
        logins[loginUrl] = idToken;
        window.AWS.config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: awsAppConfig.IdentityPoolId,
            Logins: logins
        });

        window.AWS.config.credentials.get(function (err) {
            if (err) {
                console.error("Error during login: \n", err);
                onFail(err)
            } else {
                console.log('successful login');
                onSuccess()
            }
        });
    }

    //
    // Check to see if there are credentials in localstorage and load them
    // verify and refresh creds with cognito refresh flow
    //
    static refreshLogin(onSuccess, onFail) {

        console.log("refresh login");

        if(tryCookieAuth('raven.idtoken', (attributeList, extra) => {
            if (extra && extra.identityId) {
                CognitoUtil.identityId = extra.identityId;
                console.log('CognitoUtil: set identityId from prototypeAuth cookie');
            }
            onSuccess(attributeList);
        }, onFail)) {
            // If tryCookieAuth is successful, we don't need to do anything else
            return;
        }

        var fail = function (err) {
            console.error('failed refresh login.', err);
            onFail();
            CognitoUtil.Timeout();
        }

        this.cognitoUser = CognitoUtil.userPool.getCurrentUser();
        if (!this.cognitoUser) {
            fail();
            return;
        }

        this.cognitoUser.getSession((err, result) => {
            if (err || !result) {
                fail(err);
                return;
            }

            CognitoUtil.setLoginCredentials(result);
            if (!window.AWS.config.credentials) {
                fail(err);
                return;
            }

            window.AWS.config.credentials.refresh((err) => {
                if (err) {
                    fail(err);
                    return;
                }

                CognitoUtil.cognitoUser.getUserAttributes((err, refreshLoginUserAttributesResult) => {
                    if (err) {
                        console.error(err);
                        onFail();
                        return;
                    }
                    let vendor = null; // default vendor is raven
                    for (var i = 0; i < refreshLoginUserAttributesResult.length; i++) {
                        const attributeName = refreshLoginUserAttributesResult[i].getName();
                        const attributeValue = refreshLoginUserAttributesResult[i].getValue();
                        if (attributeName === "custom:extra_user_flags" && attributeValue.indexOf("vendor_telus") !== -1) {
                            vendor = "vendor_telus";
                        }
                    }
                    const currentVendor = lsUtil.getItem('raven.vendor') || null;
                    if (vendor !== currentVendor) {
                        window.location.reload();
                    }
                    if (vendor) {
                        lsUtil.setItem('raven.vendor', vendor);
                    } else {
                        lsUtil.removeItem('raven.vendor'); // mostly just useful for debugging purposes
                    }
                    console.log('successful login refresh'); //TODO this succeeds if credentials are valid even after user has been deleted in the AWS admin panel...
                    onSuccess(refreshLoginUserAttributesResult);
                });
            });
        });
    }

    static Timeout() {
        const locale = getCurrentLocale();
        const { pathname, search, hash } = window.location;

        // Full relative URL the user attempted to access
        let redirectPath = pathname + search + hash;

        // Normalize (defensive) – ensure it starts with '/'
        if (!redirectPath.startsWith('/')) {
            redirectPath = '/' + redirectPath;
        }

        lsUtil.setItem('raven.redirect_after_login', redirectPath);       

        const searchParams = new URLSearchParams(search);
        const alreadyTimingOut = searchParams.has('timeout');
        const alreadyHasRedirect = searchParams.has('redirect_to');

        // Do not append redirect_to if:
        // - We are already on the login page (which is /:lang/)
        // - Or we are already in a timeout cycle
        // - Or redirect_to already present (avoid nesting)
        const isLoginPage = redirectPath === `/${locale}` || redirectPath === `/${locale}/`;

        const params = new URLSearchParams();
        params.set('timeout', 'true');

        if (!isLoginPage && !alreadyTimingOut && !alreadyHasRedirect) {
            
            // remove the /lang from the start of the path
            redirectPath = redirectPath.replace(`/${locale}`, '');
            
            params.set('redirect_to', redirectPath);
        }

        // Use replace so the "expired" state doesn't stay in history stack
        window.location.replace(`/${locale}?${params.toString()}`);
    }

    static getUser(idToken) {
        if (!idToken) {
            return CognitoUtil.userPool.getCurrentUser();
        } else {
            const cognitoIdToken = new CognitoIdToken({IdToken: idToken});
            const email = cognitoIdToken.payload.email;
            this.cognitoUser = new CognitoUser({ Username: email, Pool: CognitoUtil.userPool });
            return this.cognitoUser;
        }
    }

    static changePassword(oldPassword, newPassword, onSuccess, onFail) {

        try {
            this.cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
                if (err) {
                    onFail(err);
                    return;
                }
                onSuccess();
            });
        } catch (err) {
            console.error(err);
            onFail(err);
        }
    }

    static forgotPassword(email, onSuccess, onFail, callback) {

        try {
            email = email.trim().toLowerCase();
            this.cognitoUser = new CognitoUser({ Username: email, Pool: CognitoUtil.userPool });
            this.cognitoUser.forgotPassword({
                onSuccess: onSuccess,
                onFailure: onFail
            });
        } catch (err) {
            console.error(err);
            onFail(err);
        }
    }

    static confirmPassword(confirmationNumber, newPassword, onSuccess, onFail) {

        try {
            this.cognitoUser.confirmPassword(confirmationNumber, newPassword, {
                onSuccess: function (result) {
                    console.log(result);
                    onSuccess(result);
                },
                onFailure: function (err) {
                    console.log(err);
                    onFail(err);
                }
            });
        } catch (err) {
            console.error(err);
            onFail(err);
        }
    }

    static newPasswordRequired()
    {
        if(!this.cognitoUser)
            return null;

        if (this.newPasswordRequiredFlag)
        {
            return this.newPasswordRequiredFlag;
        }

        return false;

    }

    static completeNewPasswordChallenge(password, onSuccess, onFail)
    {
        try {
            this.cognitoUser.completeNewPasswordChallenge(password, {}, {
                onSuccess: (e) => {
                    this.newPasswordRequiredFlag = false;
                    onSuccess(e)
                },
                onFailure: (err) => {
                    console.error(err);
                    onFail(err);
                }
            });
        } catch(err) {
            onFail(err);
        }
    }

    static logout() {

        const { pathname, search, hash } = window.location;

        // Full relative URL the user attempted to access
        let redirectPath = pathname + search + hash;

        // Normalize (defensive) – ensure it starts with '/'
        if (!redirectPath.startsWith('/')) {
            redirectPath = '/' + redirectPath;
        }
        
        const savedPathKey = 'raven.redirect_after_login';
        let savedPath = redirectPath;

        //clear localstorage
        if (lsUtil.getLocalStorage()) {
            var ravenStoredValued = [];
            for (var i = 0; i < lsUtil.getLocalStorage().length; i++) {
                var key = lsUtil.getLocalStorage().key(i);
                if (key.indexOf('raven.') > -1) {
                    ravenStoredValued.push({ key: key, value: lsUtil.getLocalStorage().getItem(key) });
                }
            }
            // Clear AWS login information (targeting specific login details as per bugfix for RAV-8268)
            lsUtil.removeItem(lsUtil.AWS_COGNITO_USER_POOL_ID_TOKEN_JWT);
            lsUtil.removeItem(lsUtil.AWS_COGNITO_USER_ACCOUNT);
            lsUtil.removeItem(lsUtil.RC_API_JWT);
            lsUtil.removeItem(lsUtil.RC_API_JWT_EXPIRATION);


            ravenStoredValued.forEach((elem, i) => {
                lsUtil.getLocalStorage().setItem(elem.key, elem.value);
            });
        }

        var finishLogout = () => {
            if (window.AWS.config.credentials) window.AWS.config.credentials.clearCachedId();
        }
        //signs out 'all tokens' https://docs.aws.amazon.com/cognito/latest/developerguide/using-amazon-cognito-user-identity-pools-javascript-examples.html
        if (this.cognitoUser) this.cognitoUser.signOut();

        finishLogout()
        
        lsUtil.setItem(savedPathKey, savedPath);
    }

    static createUser(email, password, driverName, pendingInvite, onSuccess, onFail) {

        CognitoUtil.logout();

        email = email.trim().toLowerCase();

        this.userInformation = { email: email, password: password, driverName: driverName };

        var username = email.replace(/[^a-zA-Z0-9]+/g, '.') + Date.now();//email.tolowercase.onlya-z0-9.replaceanyotherswith.+unixtimestamp

        var attributeList = [];

        var dataEmail = {
            Name: 'email',
            Value: email
        };
        var attributeEmail = new CognitoUserAttribute(dataEmail);
        attributeList.push(attributeEmail);

        var dataPreferredUserName = {
            Name: 'preferred_username',
            Value: driverName
        }
        var attrubutePrefUsername = new CognitoUserAttribute(dataPreferredUserName);
        attributeList.push(attrubutePrefUsername);

        const defaultStage = process.env.REACT_APP_DEFAULT_STAGE;
        if (defaultStage) {
            attributeList.push({
                Name: 'custom:linked_raven_stage',
                Value: defaultStage,
            });
        }

        if(pendingInvite){
            const invite = `invite_${pendingInvite.token}_${pendingInvite.signature}`;

            attributeList.push({
                Name: 'custom:invite_details',
                Value: invite
            });
        }

        this.userPool.signUp(username, password, attributeList, null, (err, result) => {
            if (err) {
                alert(err);
                onFail(err)
                return;
            }

            this.cognitoUser = result.user;
            // console.log('Created user with name: ' + this.cognitoUser.getUsername());
            onSuccess(result.user)
        });
    }

    static resendConfirmationCode(username, onSuccess, onFail) {
        if (!username) {
            onFail(new Error('username not found'));
            return;
        }

        const cognitoUser = new CognitoUser({ Username: username, Pool: CognitoUtil.userPool });

        cognitoUser.resendConfirmationCode(function(err, result) {
            if (err) {
                onFail(err);
                return;
            }
            onSuccess(result);
        });
    }

    static confirmRegistration(username, code, onSuccess, onFail) {

        if (!username) {
            onFail(new Error('username not found'));
            return;
        }

        if (!this.cognitoUser || this.cognitoUser.getUsername() !== username) {

            this.cognitoUser = new CognitoUser({ Username: username, Pool: CognitoUtil.userPool });
        }

        this.cognitoUser.confirmRegistration(code, false, (err, result) => {
            if (err) {
                onFail(err)
                return;
            }
            // Automatically authenticate the user after successful registration
            this.authenticateRegisteredUser((user) => {
                onSuccess(user);
            }, (err) => {
                console.error("confirmRegistration authenticateRegisteredUser fail:", err);
                onFail(err);
            });
        });
    }

    static authenticateRegisteredUser(onSuccess, onFail) {

        // Check if userInformation is available
        // If not, it's probably because has refreshed/reloaded the verify-account page causing the userInformation gathered in create-account to be lost
        if(!this.userInformation){
            onFail(new Error('authenticateRegisteredUser: userInformation not found'));
            return;
        }

    
        this.cognitoUser = new CognitoUser({ Username: this.userInformation.email, Pool: CognitoUtil.userPool });

        this.cognitoUser.authenticateUser(new AuthenticationDetails({
            Username: this.userInformation.email,
            Password: this.userInformation.password
        }), {
            onSuccess: function (result) {
                CognitoUtil.setLoginCredentials(result);
                onSuccess(result.idToken.payload);
            },
            onFailure: function (err) {
                onFail(err);
            }
        });
    }

    static setUserAccountsDetails(account, multiAccount = false) {
        
        if (!account || !account.accountId) {
            throw new Error('setUserAccountsDetails: account is missing');
        }

        const payload = {
            ref: account.accountId,
            is: multiAccount ? 'yes' : 'no'
        }

        try{
            lsUtil.setObject(lsUtil.AWS_COGNITO_USER_ACCOUNT, payload);
        }
        catch(error){
            console.error('setUserAccountsDetails: Error saving to localstorage:', error);
            throw error;
        }
    }

    static getUserAccountsDetails() {
        try {
            const payload = lsUtil.getObject(lsUtil.AWS_COGNITO_USER_ACCOUNT);
            
            if (!payload) {
                return null;
            }
        
            const { ref, is } = payload;

            const isValidRef = ref && typeof ref === 'string';
            const isValidIs = is && (is === 'yes' || is === 'no');

            if(!isValidRef || !isValidIs) {
                // This will be caught by the catch block below
                throw new Error('Invalid payload structure');
            }

            return {
                account: {
                    accountId: ref
                },
                multiAccount: is === 'yes'
            }
        } catch (error) {
            console.error('getUserAccountsDetails: Error reading from localstorage:', error);
            this.clearUserAccountsDetails();
            return null;
        }
    }

    static clearUserAccountsDetails() {
        lsUtil.removeItem(lsUtil.AWS_COGNITO_USER_ACCOUNT);
    }

    static clearUserInviteAttribute(){
        const user = this.cognitoUser || CognitoUtil.userPool.getCurrentUser();
        
        if(user){
            user.getUserAttributes((err, result) => {
                if (err) {
                    console.error('clearUserInviteAttribute Error getting user attributes:', err);
                    return;
                }

                const userInviteDetailsAttribute = result.find(attr => attr.Name === 'custom:invite_details');

                if (userInviteDetailsAttribute) {                    
                    user.deleteAttributes(['custom:invite_details'], (err, result) => {
                        if (err) {
                            console.error('clearUserInviteAttribute: Error clearing the attribute:', err);
                        }
                        else {
                            console.log('clearUserInviteAttribute: Attribute cleared successfully');
                        }
                    });
                }
            });
        }
    }

    static getUserLinkedRavenStage(onSuccess, onFail) {
        const user = this.cognitoUser || CognitoUtil.userPool.getCurrentUser();

        if (user) {
            user.getUserAttributes((err, result) => {
                if (err || !Array.isArray(result)) {
                    console.error('getUserLinkedRavenStageAttribute: Error getting user attributes:', err);
                    onFail(err);
                }

                const userLinkedRavenStageAttribute = result.find(attr => attr.Name === 'custom:linked_raven_stage');

                if (userLinkedRavenStageAttribute) {
                    onSuccess(userLinkedRavenStageAttribute.Value);
                }
                else {
                    console.error('getUserLinkedRavenStageAttribute: custom:linked_raven_stage attribute not found');
                    onFail(new Error('Attribute not found'));
                }
            });
        }
        else {
            onFail(new Error('getUserLinkedRavenStageAttribute: User not found'));
        }
    }

    static getPendingInviteDetails(inviteDetailsAttribute){

        if(!inviteDetailsAttribute){
            return null;
        }

        const [token, signature] = inviteDetailsAttribute.split('_').slice(1); // Skip the 'invite' prefix

        if(!token || !signature) {
            console.error('getPendingInviteDetails: token or signature not found');
            return null;
        }

        return {token, signature};
    }

    static setUserPendingInvite(pendingInvite){
        
        if(!pendingInvite || !pendingInvite.token){
            return;
        }

        const secretKey =  pendingInvite.token;
        
        try{
            const token = jwt.encode(pendingInvite, secretKey);
            lsUtil.setItem(lsUtil.AWS_COGNITO_USER_PENDING_INVITE, token);
        }
        catch(error){
            console.error('Error encoding AWS_COGNITO_USER_PENDING_INVITE:', error);
        }
    }

    static getUserPendingInvite(secretKey) {
        const pendingInvite = lsUtil.getItem(lsUtil.AWS_COGNITO_USER_PENDING_INVITE);
        
        if (!secretKey || !pendingInvite) {
            return null;
        }

        try {
            return jwt.decode(pendingInvite, secretKey);
        } 
        catch (error) {

            // The secret key is not matching the token
            console.error('Error decoding AWS_COGNITO_USER_PENDING_INVITE:', error);

            // Clear the old pending invite
            this.clearUserPendingInvite();

            return null;
        }
    }

    static clearUserPendingInvite(){
        lsUtil.removeItem(lsUtil.AWS_COGNITO_USER_PENDING_INVITE);
    }
}
